module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
(function(fox) {
	"use strict";

	var _ = {
		getTranslation: function(alias) {
			var translation = {
				'seemsYouOffline': fox.i18n.getTranslation('seemsYouOffline', 'Oops... Seems you\'re gone offline. Please check your network settings', 'notifications'),
				'deviceConnectedInternet': fox.i18n.getTranslation('deviceConnectedInternet', 'Your device is connected to the internet', 'notifications')
			};

			return translation[alias] || '';
		}
	};

	fox.registerWidget('OfflineCheckerNotifications', {

		configure: function(options) {
			this.offlineCheckerEvents = [
				'connection.down',
				'connection.up',
				'connection.checking',
				'connection.reconnect:started',
				'connection.reconnect:connecting',
				'connection.reconnect:stopped',
				'connection.reconnect:failure'
			];
			
			this.callParent('configure', arguments);
		},

		running: function () {
			this.offlineChecker = fox.wom.selectFirst('@root #offlineChecker');

			fox.each(this.offlineCheckerEvents, function (e) {
				this.handleEvent(this.offlineChecker, e, this._handleEvents)
			}, this);

			this.callParent('running', arguments);
		},

		_handleEvents: function (obj, w, e) {
			
			switch(e) {
				case 'connection.down':
					this.showConnectionDownNotice()
				break;

				case 'connection.up':
					this.showConnectionUpNotice()
				break;

				case 'connection.reconnect:connecting':
					this.showReconnectingNotice()
				break;

				// case 'connection.reconnect:stopped':
				// 	//this.showReconnectingNotice()
				// 	console.log('connection.reconnect:stopped')
				// break;

				// case 'connection.reconnect:failure':
				// 	//this.showReconnectingNotice();
				// 	// window.setTimeout(fox.bind(function () {
				// 	// 	this.offlineChecker.checkConnectionStatus()
				// 	// }, this), 2000)
				// break;
			}

		},

		showConnectionDownNotice: function () {
			fox.wom.selectFirst('~#throughNotifications').pushNotification({
				noticeTemplate: 'connection_notice',
				noticeType: 'error',
				noticeMessage: _.getTranslation('seemsYouOffline'),
				noticeAlias: 'offlineNotice'
			});
		},

		showConnectionUpNotice: function () {
			fox.wom.selectFirst('~#throughNotifications').pushNotification({
				noticeTemplate: 'connection_notice',
				noticeType: 'success',
				noticeMessage: _.getTranslation('deviceConnectedInternet'),
				delayClose: 3000,
				noticeAlias: 'offlineNotice'
			});
		},

		showReconnectingNotice: function () {
			fox.wom.selectFirst('~#throughNotifications').pushNotification({
				noticeTemplate: 'connection_notice',
				noticeType: 'attempt',
				noticeAlias: 'offlineNotice'
			});
		},
		
	}, 'Controller');

})(fox);

 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/admin/common/frame/widget/offlineCheckerNotifications.js
// module id = 335
// module chunks = 2